var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.$vuetify.theme.dark?'dark':'light'].backgroundLayouts})},[_c('default-bar'),_c('default-view'),_c('default-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }